<template lang="pug">
v-container.pa-0(grid-list-lg)
  v-layout.mb-2(row wrap align-center)
    v-flex(:xs12='!hideTime' :xs9='hideTime' sm6)
      v-menu(
        :close-on-content-click='false'
        v-model='dateMenu'
        :nudge-right='150'
        transition='scale-transition'
        min-width='290px'
        offset-y full-width lazy
      )
        v-text-field.picker(slot='activator' v-model='date' :label='dateLabel || $t("dateOfN", [name])' prepend-icon='event' :hint='`(${$t("aboutN", [fromNow(value)])})`' persistent-hint readonly)
        v-date-picker(v-model='date' no-title show-current @input='dateMenu = false')
    v-flex(xs12 sm6 :class='{ hide: hideTime }')
      v-text-field.picker(slot='activator' v-model='time' :label='timeLabel || $t("timeOfN", [name])' prepend-icon='access_time' type='time')
    v-flex(:xs12='!hideTime' :xs3='hideTime' sm6 v-if='showDelete')
      v-btn(icon small flat color='red' @click='$emit(`del`)'): v-icon(small) clear
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateTimePicker',
  props: {
    name: {
      type: String,
      default: null,
    },
    dateLabel: {
      type: String,
      default: null,
    },
    timeLabel: {
      type: String,
      default: null,
    },
    value: {
      // type: Number,
      default: null,
    },
    hideTime: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dateMenu: false,
      timeMenu: false,
      date: null,
      time: null,
    }
  },
  mounted () {
    this.convertUnixToDateTime()
  },
  methods: {
    convertDateTimeToUnix () {
      const date = this.date
      const time = this.time

      return (date && time)
        ? parseInt(moment(`${date} ${time}:59`, 'YYYY-MM-DD HH:mm:ss').format('x'))
        : null
    },
    convertUnixToDateTime () {
      const timestamp = parseInt(this.value)
      if (!isNaN(timestamp) && typeof timestamp === 'number') {
        this.date = moment(this.value, 'x').format('YYYY-MM-DD')
        this.time = moment(this.value, 'x').format('HH:mm')
      }
    },
    fromNow (_) {
      let text = moment(_).locale('zh-tw').fromNow()
      text = text.replace(/內/g, '後')
      return text
    },
  },
  watch: {
    date () {
      this.$emit('input', this.convertDateTimeToUnix())
    },
    time () {
      this.$emit('input', this.convertDateTimeToUnix())
    },
    value () {
      this.convertUnixToDateTime()
    },
  },
}
</script>

<style scoped lang="sass">
input[type="time"]::-webkit-clear-button, input[type="date"]::-webkit-clear-button, input[type="date"]::-webkit-calendar-picker-indicator
  display: none

.hide
  display: none
</style>

<i18n src="@/lang/components/dateTimePicker.json"></i18n>
